module.exports = __webpack_public_path__ + "img/products-slider.8c712a15.webp";